import React from "react";

const Header = () => {
  return (
    <div className="header">
      <img src="./images/banner.jpg" alt="" />
    </div>
  );
};

export default Header;
